import { GridViewIcon, ListViewIcon } from '@cfs-fixings/shared'
import ViewPickerItem from './ViewPickerItem'

type viewType = 'list' | 'grid'

type PropTypes = {
  selectedOption?: viewType
  onOptionSelected: (option: viewType) => void
}

const ViewPicker = ({ selectedOption = 'list', onOptionSelected }: PropTypes) => {
  return (
    <div className="flex flex-row gap-px">
      <ViewPickerItem
        selected={selectedOption === 'list'}
        onOptionSelected={() => onOptionSelected('list')}
      >
        <ListViewIcon className="w-[24px] h-[24px]" />
      </ViewPickerItem>
      <ViewPickerItem
        selected={selectedOption === 'grid'}
        onOptionSelected={() => onOptionSelected('grid')}
      >
        <GridViewIcon className="w-[24px] h-[24px]" />
      </ViewPickerItem>
    </div>
  )
}

export default ViewPicker
